import { useEffect, useState } from "react";
import api from "../api/api";
import "../styles/components/Products.scss";
import ProductCard from "../components/ProductCard";
import Breadcrumb from "../components/Breadcrumb";
import Loader from "../components/Loader";
import EmptyState from "../components/EmptyState";
import LoadMoreButton from "../components/LoadMoreButton";

const BREADCRUMB_ITEMS = [{ label: "Home", to: "/" }, { label: "All Products" }];

function AllProducts() {
  const [products, setProducts] = useState([]);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    const fetchProducts = async () => {
      setLoading(true);
      setError("");

      try {
        const res = await api.get("/products");
        const data = res.data?.results || [];

        if (active) {
          setProducts(Array.isArray(data) ? data.filter((p) => p && p.id) : []);
          setMeta(res.data?.meta || null);
        }
      } catch (err) {
        console.error(err);
        if (active) setError("Failed to load products");
      } finally {
        if (active) setLoading(false);
      }
    };

    fetchProducts();

    return () => {
      active = false;
    };
  }, []);

  const hasMore = Boolean(meta && meta.current_page < meta.last_page);

  const handleLoadMore = async () => {
    if (!hasMore || loadingMore) return;

    setLoadingMore(true);

    try {
      const res = await api.get("/products", { params: { page: meta.current_page + 1 } });
      const data = res.data?.results || [];

      setProducts((prev) => [...prev, ...(Array.isArray(data) ? data.filter((p) => p && p.id) : [])]);
      setMeta(res.data?.meta || null);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingMore(false);
    }
  };

  return (
    <div className="products-container reveal">
      <div className="page-head">
        <Breadcrumb items={BREADCRUMB_ITEMS} />
        <h1 className="page-title page-title--eyebrow page-title--lg">
          All Products
        </h1>
      </div>

      {loading ? (
        <Loader message="Loading products..." />
      ) : error ? (
        <EmptyState message={error} variant="error" />
      ) : products.length === 0 ? (
        <EmptyState message="No products found" />
      ) : (
        <>
          <div className="products-grid">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>

          {hasMore && (
            <LoadMoreButton onClick={handleLoadMore} loading={loadingMore} />
          )}
        </>
      )}
    </div>
  );
}

export default AllProducts;